import { createReducer, on } from '@ngrx/store';
import { organizationInitialState, OrganizationState } from './organization.state';
import { loadDepotsSuccess, loadExternalCredentialsSuccess } from './organization.actions';

export const organizationReducer = createReducer(
    organizationInitialState,
    on(loadDepotsSuccess, (state: OrganizationState, { depots }) => {
        return { ...state, depots: depots };
    }),
    on(loadExternalCredentialsSuccess, (state: OrganizationState, { externalCredentials }) => {
        return { ...state, externalCredentials: externalCredentials };
    })
);
